import { UserClaimInfo } from 'components/common';

export const getAllocation = (claimInfo?: UserClaimInfo): number => {
  return Boolean(claimInfo) ? parseInt(claimInfo!.amount, 16) : 0;
};
